// NotFoundPage.js - Página 404 personalizada ACHIPO
import React from 'react';
import { Link } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import '../App.css';

const NotFoundPage = () => {
  return (
    <div className="not-found-page">
      <Header />
      <main className="not-found-content">
        <div className="not-found-card">
          <div className="not-found-icon">404</div>
          <h1 className="not-found-title">Página no encontrada</h1>
          <p className="not-found-message">
            La ruta que buscas no existe o ha sido movida. 
            Puedes volver al inicio o explorar nuestras secciones principales.
          </p>
          <div className="not-found-actions">
            <Link to="/" className="btn btn-primary btn-lg">
              ← Volver al Inicio
            </Link>
            <Link to="/events" className="btn btn-secondary btn-lg">
              📅 Eventos
            </Link>
            <Link to="/shop" className="btn btn-outline btn-lg">
              🛒 Tienda
            </Link>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default NotFoundPage;
